<template>
  <header class="main-header container-fluid bg-white">
    <div class="row h-100 align-content-center" :class="{ 'justify-content-center': boxed, 'justify-content-between': !boxed }">
      <div class="col-auto d-flex">
        <div class="py-3">
          <Logo :to="{ name: 'projects.list' }" :disable-link="noLinkToHome">ViSEA</Logo>
        </div>
      </div>
      <div class="col">
        <BBreadcrumb v-if="$root.project">
          <BBreadcrumbItem :to="{ name: 'projects.list' }">Progetti</BBreadcrumbItem>
          <BBreadcrumbItem :to="{ name: 'projects.show' }">{{ $root.project.name }}</BBreadcrumbItem>
          <BBreadcrumbItem v-if="$root.module" :to="{ name: 'modules.show' }">{{ $root.module.name }}</BBreadcrumbItem>
          <BBreadcrumbItem v-if="$root.point" :to="{ name: 'points.show' }">{{ $root.point.title }}</BBreadcrumbItem>
        </BBreadcrumb>
      </div>
      <div class="col-auto d-flex align-items-center" v-if="!boxed">
        <div class="d-lg-none">
          <Hamburger class="col-auto d-flex align-items-center d-lg-none px-4"></Hamburger>
        </div>
        <AccountDropdown class="d-none d-lg-block" v-if="isLogged" />
        <div v-else class="ml-3 d-none d-lg-block">
          <router-link :to="{ name: 'login' }">Login</router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import rolesMixin from '../../../mixins/roles';

import { BBreadcrumb, BBreadcrumbItem } from 'bootstrap-vue';

export default {
  name: 'layout-admin-header',
  mixins: [rolesMixin],
  props: {
    boxed: {
      type: Boolean,
      default: false,
    },
    noLinkToHome: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    AccountDropdown: () => import('../Account/AccountDropdown'),
    Logo: () => import('../Layout/Logo'),
    Hamburger: () => import('../../../libs/Sidebar/components/Hamburger/CssHamburger'),
  },
};

</script>

<style lang="scss">

$main-header-border-bottom-color: #1C2023 !default;
$main-header-box-shadow-color: #1C2023 !default;

.main-header {
    box-shadow: 0 0 8px rgba($main-header-box-shadow-color, 0.3);
    position: relative;
    z-index: 10;
}

</style>
